'use client';

import { FC } from 'react';

import dynamic from 'next/dynamic';

import { useVasModalControls } from '@telialt/core-eshop/src/CartSummaryBox/ValueAddedServices/useVasModalControls';
import { useAskToUnRestrictLeasingModalControls } from '@telialt/core-eshop/src/components/AskToUnRestrictLeasingModal/useAskToUnRestrictLeasingModalControls';

import { useGiftDetailsModalControls } from './GiftDetailsModal/useGiftDetailsModalControls';
import {
    useSpecialOfferGiftModalControls,
    useSpecialOfferSingleModalControls,
} from './SpecialOffers/useSpecialOfferModalControls';

export const ProductOrderCart = dynamic(
    () => import('./ProductOrderCart/ProductOrderCart').then((mod) => mod.ProductOrderCart),
    { ssr: false },
);

const VasModal = dynamic(
    () => import('@telialt/core-eshop/src/CartSummaryBox/ValueAddedServices/VasModal').then((mod) => mod.VasModal),
    { ssr: false },
);

const SpecialOfferGiftModal = dynamic(
    () => import('./SpecialOffers/modals/SpecialOfferGiftModal').then((mod) => mod.SpecialOfferGiftModal),
    { ssr: false },
);

const SpecialOfferSingleModal = dynamic(
    () => import('./SpecialOffers/modals/SpecialOfferSingleModal').then((mod) => mod.SpecialOfferSingleModal),
    { ssr: false },
);

const GiftDetailsModal = dynamic(
    () => import('./GiftDetailsModal/GiftDetailsModal').then((mod) => mod.GiftDetailsModal),
    { ssr: false },
);

const AskToUnRestrictLeasingModal = dynamic(
    () =>
        import('@telialt/core-eshop/src/components/AskToUnRestrictLeasingModal/AskToUnRestrictLeasingModal').then(
            (mod) => mod.AskToUnRestrictLeasingModal,
        ),
    { ssr: false },
);

export const VasModalLazy: FC = () => {
    const { isModalOpen } = useVasModalControls();

    return isModalOpen ? <VasModal /> : null;
};

export const SpecialOfferGiftModalLazy: FC = () => {
    const { isModalOpen } = useSpecialOfferGiftModalControls();

    return isModalOpen ? <SpecialOfferGiftModal /> : null;
};

export const SpecialOfferSingleModalLazy: FC = () => {
    const { isModalOpen } = useSpecialOfferSingleModalControls();

    return isModalOpen ? <SpecialOfferSingleModal /> : null;
};

export const GiftDetailsModalLazy: FC = () => {
    const { isModalOpen } = useGiftDetailsModalControls();

    return isModalOpen ? <GiftDetailsModal /> : null;
};

export const AskToUnRestrictLeasingModalLazy: FC = () => {
    const { isModalOpen } = useAskToUnRestrictLeasingModalControls();

    return isModalOpen ? <AskToUnRestrictLeasingModal /> : null;
};
